var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamiliaWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#DE1212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6585 12.9512C24.6585 11.878 25.5366 11 26.6098 11C27.6829 11 28.561 11.878 28.561 12.9512C28.561 14.0244 27.6829 14.9024 26.6098 14.9024C25.5366 14.9024 24.6585 14.0244 24.6585 12.9512ZM28.561 30.5122V24.6585H31L28.561 17.2439C28.2683 16.4634 27.5854 15.878 26.7073 15.878H26.6098C25.7317 15.878 25.0488 16.4634 24.7561 17.2439L23.878 19.7805C24.9512 20.3659 25.6341 21.439 25.6341 22.8049V30.5122H28.561ZM21.2439 20.2683C22.0244 20.2683 22.7073 19.5854 22.7073 18.8049C22.7073 18.0244 22.0244 17.3415 21.2439 17.3415C20.4634 17.3415 19.7805 18.0244 19.7805 18.8049C19.7805 19.5854 20.4634 20.2683 21.2439 20.2683ZM14.4146 14.9024C15.4878 14.9024 16.3659 14.0244 16.3659 12.9512C16.3659 11.878 15.4878 11 14.4146 11C13.3415 11 12.4634 11.878 12.4634 12.9512C12.4634 14.0244 13.3415 14.9024 14.4146 14.9024ZM16.3659 30.5122V23.6829H17.8293V17.8293C17.8293 16.7561 16.9512 15.878 15.878 15.878H12.9512C11.878 15.878 11 16.7561 11 17.8293V23.6829H12.4634V30.5122H16.3659ZM22.7073 30.5122V26.6098H23.6829V22.7073C23.6829 21.9268 23 21.2439 22.2195 21.2439H20.2683C19.4878 21.2439 18.8049 21.9268 18.8049 22.7073V26.6098H19.7805V30.5122H22.7073Z",
    fill: "#FCE7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamiliaWarning);
export default __webpack_public_path__ + "static/media/FamiliaWarning.7823b5033120ce5383e1255dd6832577.svg";
export { ForwardRef as ReactComponent };